import { useState, useRef, useLayoutEffect } from 'react';
import { useSize } from 'ahooks';
export function useTextOverflow({ refreshKey } = {}) {
    const [isTextOverflow, setIsTextOverflow] = useState(false);
    const textRef = useRef(null);
    const root = textRef.current;
    const size = useSize(textRef);
    useLayoutEffect(() => {
        if (root) {
            setIsTextOverflow(textRef.current.scrollHeight > textRef.current.clientHeight ||
                textRef.current.scrollWidth > textRef.current.clientWidth);
        }
    }, [refreshKey, root, size]);
    return {
        isTextOverflow,
        textRef,
    };
}
export default useTextOverflow;
//# sourceMappingURL=index.js.map